function bindCardCombinedSwatches() {
  if (window.__cardCombinedSwatchesBound) return
  window.__cardCombinedSwatchesBound = true

  const ringClasses = [
    'tw-ring-2',
    'tw-ring-[var(--copec-dark-blue)]',
    'tw-ring-offset-1',
  ]

  const sameUrl = (a, b) => {
    try {
      const left = new URL(a, window.location.origin)
      const right = new URL(b, window.location.origin)
      return left.pathname === right.pathname && left.search === right.search
    } catch (error) {
      return a === b
    }
  }

  const productLinks = (card) =>
    Array.from(card.querySelectorAll('a[href]')).filter(
      (link) => !link.hasAttribute('data-combined-swatch'),
    )

  const productImages = (card) =>
    Array.from(card.querySelectorAll('.card__media img, .card__inner img'))

  const rememberOriginals = (card) => {
    if (card.dataset.combinedReady === 'true') return

    const heading = card.querySelector('.card__heading a')
    card.dataset.combinedOriginalUrl = heading
      ? heading.getAttribute('href') || ''
      : ''

    productImages(card).forEach((img) => {
      img.dataset.combinedOriginalSrc = img.getAttribute('src') || img.src || ''
      img.dataset.combinedOriginalSrcset = img.getAttribute('srcset') || ''
      img.dataset.combinedOriginalSizes = img.getAttribute('sizes') || ''
    })

    productLinks(card).forEach((link) => {
      link.dataset.combinedOriginalHref = link.getAttribute('href') || ''
    })

    const variantInput = card.querySelector('input.product-variant-id')
    card.dataset.combinedOriginalVariant = variantInput
      ? variantInput.value || ''
      : ''
    card.dataset.combinedOriginalAvailable =
      variantInput && !variantInput.disabled ? 'true' : 'false'

    card.dataset.combinedReady = 'true'
  }

  const setImage = (img, src) => {
    img.removeAttribute('srcset')
    img.removeAttribute('sizes')
    img.setAttribute('src', src)
    img.src = src
    img.loading = 'eager'
  }

  const showFirstSlide = (card) => {
    const swiperEl = card.querySelector('.card__media .swiper')
    let swiper = swiperEl && swiperEl.swiper

    if (!swiper && window.Alpine) {
      const host = card.querySelector('.card__media [x-data]')
      if (host) {
        try {
          const data = window.Alpine.$data(host)
          swiper = data && data._s
        } catch (error) {
          swiper = null
        }
      }
    }

    if (!swiper || typeof swiper.slideTo !== 'function') return
    if (swiper.params.loop && typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(0, 0)
      return
    }
    swiper.slideTo(0, 0)
  }

  const restoreImage = (img) => {
    const src = img.dataset.combinedOriginalSrc
    const srcset = img.dataset.combinedOriginalSrcset
    const sizes = img.dataset.combinedOriginalSizes
    if (!src) return
    if (srcset) {
      img.setAttribute('srcset', srcset)
    } else {
      img.removeAttribute('srcset')
    }
    if (sizes) {
      img.setAttribute('sizes', sizes)
    } else {
      img.removeAttribute('sizes')
    }
    img.setAttribute('src', src)
    img.src = src
  }

  document.addEventListener(
    'click',
    (event) => {
      const swatch = event.target.closest('[data-combined-swatch]')
      if (!swatch) return

      const card = swatch.closest('.product-card-wrapper')
      if (!card) return

      event.preventDefault()
      event.stopPropagation()

      rememberOriginals(card)

      const siblingUrl =
        swatch.getAttribute('data-sibling-url') ||
        swatch.getAttribute('href') ||
        ''
      let siblingImage = swatch.getAttribute('data-sibling-image') || ''
      if (!siblingImage) {
        const swatchEl = swatch.querySelector('.swatch')
        const bg = swatchEl
          ? swatchEl.style.getPropertyValue('--swatch--background')
          : ''
        const bgMatch = bg.match(/url\((['"]?)(.+?)\1\)/)
        if (bgMatch && bgMatch[2]) {
          siblingImage = bgMatch[2].replace(/width=\d+/g, 'width=720')
        }
      }
      const originalUrl = card.dataset.combinedOriginalUrl || ''
      const siblingVariant = swatch.getAttribute('data-sibling-variant') || ''
      const originalVariant = card.dataset.combinedOriginalVariant || ''
      const isOriginal = siblingVariant
        ? siblingVariant === originalVariant
        : sameUrl(siblingUrl, originalUrl)

      card.querySelectorAll('[data-combined-swatch]').forEach((item) => {
        item.removeAttribute('aria-current')
        item.classList.remove(...ringClasses)
      })
      swatch.setAttribute('aria-current', 'true')
      swatch.classList.add(...ringClasses)

      productLinks(card).forEach((link) => {
        const nextHref = isOriginal
          ? link.dataset.combinedOriginalHref || originalUrl
          : siblingUrl
        if (nextHref) link.setAttribute('href', nextHref)
      })

      const variantInput = card.querySelector('input.product-variant-id')
      const submitButton = card.querySelector('.quick-add [type="submit"]')
      if (variantInput && (siblingVariant || isOriginal)) {
        variantInput.value = isOriginal
          ? originalVariant || variantInput.value
          : siblingVariant || variantInput.value

        const available = isOriginal
          ? card.dataset.combinedOriginalAvailable !== 'false'
          : swatch.getAttribute('data-sibling-available') !== 'false'

        variantInput.disabled = !available
        if (submitButton) {
          if (available) {
            submitButton.removeAttribute('disabled')
          } else {
            submitButton.setAttribute('disabled', '')
          }
        }
      }

      if (isOriginal) {
        productImages(card).forEach(restoreImage)
        showFirstSlide(card)
        return
      }

      if (!siblingImage) return

      productImages(card).forEach((img) => setImage(img, siblingImage))
      showFirstSlide(card)
    },
    true,
  )
}

const updateScrollHint = (wrap) => {
  const scroller = wrap.querySelector('.card-product-combined-swatches')
  if (!scroller) return

  const maxScroll = scroller.scrollWidth - scroller.clientWidth
  const scrollable = maxScroll > 6
  wrap.classList.toggle('is-scrollable', scrollable)
  scroller.classList.toggle('is-scrollable', scrollable)

  const dots = wrap.querySelector('[data-combined-dots]')
  if (!scrollable) {
    wrap.classList.remove('has-more-left', 'has-more-right')
    if (dots) dots.hidden = true
    return
  }

  const atStart = scroller.scrollLeft <= 6
  const atEnd = scroller.scrollLeft >= maxScroll - 6
  wrap.classList.toggle('has-more-left', !atStart)
  wrap.classList.toggle('has-more-right', !atEnd)

  if (dots) {
    dots.hidden = false
    const ratio = maxScroll <= 0 ? 0 : scroller.scrollLeft / maxScroll
    const index = ratio < 0.33 ? 0 : ratio < 0.67 ? 1 : 2
    dots.querySelectorAll('span').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index)
    })
  }
}

const initScrollHints = () => {
  document.querySelectorAll('.card-product-combined-swatches-wrap').forEach((wrap) => {
    const scroller = wrap.querySelector('.card-product-combined-swatches')
    if (!scroller) return

    if (wrap.dataset.combinedHintReady !== 'true') {
      wrap.dataset.combinedHintReady = 'true'
      scroller.addEventListener('scroll', () => updateScrollHint(wrap), {
        passive: true,
      })
    }

    updateScrollHint(wrap)
  })
}

bindCardCombinedSwatches()

let hintTimer = null
const scheduleHintInit = () => {
  clearTimeout(hintTimer)
  hintTimer = setTimeout(initScrollHints, 50)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollHints)
} else {
  initScrollHints()
}

window.addEventListener('resize', scheduleHintInit)

if (document.body) {
  const observer = new MutationObserver(scheduleHintInit)
  observer.observe(document.body, { childList: true, subtree: true })
}